<template>
  <logged-in>
    <dashboard />  
    <template v-slot:fallback>
      <dashboard />  
    </template>
  </logged-in>  
</template>
<script>     
  import Dashboard from '@/views/dashboard/Dashboard'
  export default {
    components: {
      Dashboard,
    },
  }
</script>
